











































import { Component, Prop, Vue } from 'vue-property-decorator';

import MmHintedButton from '../../components/MmHintedButton.vue';
import { MmAssignmentImportPreview } from '../../types/dto';

const KEY_PREFIX = 'priceMonitoring.mobileMonitoring.assignments.';

@Component({
	components: { MmHintedButton },
})
export default class AssignmentImportConfirm extends Vue {
	@Prop({ default: false }) readonly visible!: boolean;

	@Prop({ default: null }) readonly preview!: MmAssignmentImportPreview | null;

	@Prop({ default: false }) readonly loading!: boolean;

	get titleText(): string {
		return this.$t(KEY_PREFIX + 'confirmTitle') as string;
	}

	get applyText(): string {
		return this.$t(KEY_PREFIX + 'confirmApply') as string;
	}

	get cancelText(): string {
		return this.$t('shared.actions.cancel') as string;
	}

	get cancelDisabledReason(): string {
		return this.$t('priceMonitoring.mobileMonitoring.states.loading') as string;
	}

	get tasksWarningText(): string {
		return this.$t(KEY_PREFIX + 'importTasksWarning') as string;
	}

	get rowsInFileText(): string {
		return this.$t(KEY_PREFIX + 'confirmRowsInFile', { count: this.readCount('rowsInFile') }) as string;
	}

	get willUpdateText(): string {
		return this.$t(KEY_PREFIX + 'confirmWillUpdate', { count: this.readCount('willUpdate') }) as string;
	}

	get willReassignText(): string {
		return this.$t(KEY_PREFIX + 'confirmWillReassign', { count: this.readCount('willReassign') }) as string;
	}

	get willClearText(): string {
		return this.$t(KEY_PREFIX + 'confirmWillClear', { count: this.readCount('willClear') }) as string;
	}

	/** Проверяем именно null: ноль затронутых заданий — законный ответ, и прятать его нельзя */
	get hasAffectedTasks(): boolean {
		return this.preview !== null && this.preview.affectedActiveTasks !== null;
	}

	get affectedTasksText(): string {
		const value = this.preview !== null && this.preview.affectedActiveTasks !== null
			? this.preview.affectedActiveTasks
			: 0;

		return this.$t(KEY_PREFIX + 'confirmAffectedTasks', { count: value }) as string;
	}

	handleApply(): void {
		this.$emit('apply');
	}

	handleCancel(): void {
		if (this.loading) {
			return;
		}

		this.$emit('cancel');
	}

	private readCount(field: 'rowsInFile' | 'willUpdate' | 'willReassign' | 'willClear'): number {
		if (this.preview === null) {
			return 0;
		}

		const value = this.preview[field];

		return typeof value === 'number' ? value : 0;
	}
}
